import { ALERT_STATUS, IAlertTypeData } from "@home-health-notify/domain";
import {
  ALERT_MESSAGE_TYPE,
  OrganizationContext,
  useScrollLock,
} from "hhn-commons";
import { useCallback, useContext, useState } from "react";
import { AlertWidgetWrapper } from "../Alert.style";
import PriorityAlertHeader from "../alertItemHeader/PriorityAlertHeader";
import { AlertMessagesList as PriorityAlertsList } from "../AlertMessagesList";
import ReadAlertsWidget from "../ReadAlertWidget";

const PriorityAlert = ({
  counter,
  alerts: priorityAlerts,
}: {
  counter: number;
  alerts: IAlertTypeData;
}) => {
  const { selectedOrgUser } = useContext(OrganizationContext);

  const [priorityAlertLoading, setPriorityAlertLoading] = useState(false);

  const { concurrencySafe } = useScrollLock();

  const fetchPriorityMessages = useCallback(async () => {
    await concurrencySafe(async () => {
      if (priorityAlerts.hasNext && selectedOrgUser) {
        setPriorityAlertLoading(true);
        await selectedOrgUser.alert.fetchPriorityAlerts();
        setPriorityAlertLoading(false);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrgUser?.alert, priorityAlerts.hasNext]);

  const unReadPriorityAlertData = priorityAlerts.data.filter(
    priority => priority.alertStatus === ALERT_STATUS.UNREAD,
  );
  const readPriorityAlertData = priorityAlerts.data.filter(
    priority => priority.alertStatus === ALERT_STATUS.READ,
  );
  return (
    <AlertWidgetWrapper>
      <PriorityAlertHeader counter={counter} />
      <PriorityAlertsList
        type={ALERT_MESSAGE_TYPE.PRIORITY}
        alertTypeData={unReadPriorityAlertData}
        onScroll={fetchPriorityMessages}
        isDataLoading={priorityAlertLoading}
      />
      {readPriorityAlertData.length > 0 && (
        <ReadAlertsWidget title="Read Priority">
          <PriorityAlertsList
            type={ALERT_MESSAGE_TYPE.PRIORITY}
            alertTypeData={readPriorityAlertData}
            onScroll={async () => {}}
            isDataLoading={false}
            restTop={0}
          />
        </ReadAlertsWidget>
      )}
    </AlertWidgetWrapper>
  );
};
export default PriorityAlert;
